import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    rowVersion: null,
    
    etiquetaProveedorDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_ETIQUETA_PROVEEDOR'(state, etiquetaProveedorId) {
        state.id = etiquetaProveedorId;
        state.nombre = '';
        state.rowVersion = null;
    },
    'SET_ETIQUETA_PROVEEDOR'(state, etiquetaProveedor) {
        state.nombre = etiquetaProveedor.nombre.toUpperCase().trim();
        state.rowVersion = etiquetaProveedor.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.etiquetaProveedorDatos = [];
    },
    'SET_DATOS'(state, datos) {
        state.etiquetaProveedorDatos = datos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, etiquetaProveedorId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_ETIQUETA_PROVEEDOR', etiquetaProveedorId);

            if (etiquetaProveedorId != 0) {
                apiAxios.get('etiquetasproveedores/' + etiquetaProveedorId + '/abm' ) 
                .then(res => {
                    commit('SET_ETIQUETA_PROVEEDOR', res.data);
                    resolve();
                })
                .catch(error => reject(error))
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },    
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let etiquetaProveedor = {
                nombre: state.nombre.toUpperCase().trim(),
                inactivo: state.inactivo,
            }

            let url = 'etiquetasproveedores';
            if (state.id != 0) {
                url += '/' + state.id;
                etiquetaProveedor.rowVersion = state.rowVersion;
            }
            
            apiAxios.post(url, etiquetaProveedor)
                .then(() => {
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getDatos ( { commit }, etiquetaProveedorId ) {
        return new Promise((resolve, reject) => {

            commit('INICIALIZAR_DATOS');
            
            let getDatos = false;
            if (etiquetaProveedorId) {
                if (etiquetaProveedorId != 0) {
                    getDatos = true;
                }
            }

            if (getDatos) {
                apiAxios.get('etiquetasproveedores/' + etiquetaProveedorId ) 
                .then(res => {
                    var datos = [
                        { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                        { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                    ];
                    commit('SET_DATOS', datos);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}